import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import union from "./img/union.svg";
import bacterium from "./img/bacterium.svg";
import { setTransformationValue } from "./store/actions";
import styles from "./style.module.scss";

import { injectIntl, FormattedMessage } from "react-intl";

const dynamicImageImport = (path) => {
  return import(/* @vite-ignore */ `${path}`)
    .then((module) => module.default)
    .catch((err) => {
      console.error("Failed to load image:", err);
      return null;
    });
};

const DynamicImageComponent = (props) => {
  const { src, ...newProps } = props;
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    dynamicImageImport(src).then((src) => {
      setImageSrc(src);
    });
  }, [src]);

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img src={imageSrc} {...newProps} />;
};

class Predictions57 extends Component {
  // Handles image click events
  imageClicked = (tube) => {
    this.props.setTransformationValue({
      section: "predictions",
      transformation: this.props.component_type,
      value: tube,
    });
  };

  render() {
    const { heading, tubes, selected } = this.props;

    return (
      <div className={styles.sectionInteractive}>
        <h5 className={styles.sectionHeading}>
          <FormattedMessage
            id={heading}
            defaultMessage={heading}
            description=""
          />
        </h5>

        <div className={styles.transformTubes}>
          <div className={styles.transformTubes__tube}>
            {tubes.map((tube) => (
              <div key={tube.id}>
                <DynamicImageComponent
                  draggable={false}
                  onClick={() => this.imageClicked(tube.id)}
                  onKeyDown={(e) => {
                    if (e.which === 13 || e.which === 32) {
                      this.imageClicked(tube.id);
                    }
                  }}
                  src={`./img/tube-${tube.id}${
                    tube.id === selected ? "-h" : ""
                  }-${this.props.intl.locale}.svg`}
                  alt={this.props.intl.formatMessage({
                    id: tube.alt,
                    defaultMessage: tube.alt,
                    description: "",
                  })}
                />
              </div>
            ))}
          </div>
          <div className={styles.transformTubes__footer}>
            <TypeLabel
              image={union}
              label={this.props.intl.formatMessage({
                id: "Plasmid",
                defaultMessage: "Plasmid",
                description: "",
              })}
            />
            <TypeLabel
              image={bacterium}
              label={this.props.intl.formatMessage({
                id: "Bacterium",
                defaultMessage: "Bacterium",
                description: "",
              })}
            />
          </div>
        </div>
      </div>
    );
  }
}

// Component for displaying type label with image
const TypeLabel = ({ image, label }) => (
  <div className={styles.type}>
    <div className={`${styles.type__plasmid} ${styles.type__bacteria}`}>
      <img src={image} alt={label} />
      <div>
        <FormattedMessage id={label} defaultMessage={label} description="" />
      </div>
    </div>
  </div>
);

const mapStateToProps = (state, ownProps) => {
  return state.transformingBacteria["predictions"]
    ? {
        selected:
          state.transformingBacteria["predictions"][ownProps.component_type],
      }
    : {};
};

export const TransformingBacteriaPredictions = connect(mapStateToProps, {
  setTransformationValue,
})(injectIntl(Predictions57));
